import './Dashboard.css';
import { useEffect, useRef, useState } from 'react'
import { default as Drawer } from '../../Components/Drawer/Drawer'
import { DashboardProvider, useDashboard } from '../../context/DashboardContext'
import { useTranslation } from 'react-i18next';
import { useToast } from '../../context/ToastContext';
import { ProfileProvider, useProfile } from '../../context/ProfileContext';
import { AnalyticsProvider } from '../../context/AnalyticsContext';
import Main from './Main/Main';
import Links from './Links/Links';
import Appearance from './Appearance/Appearance';
import Profile from './Profile/Profile';
import Preview from './Preview/Preview';
import Settings from './Settings/Settings';
import ContainerView from '../../Components/ContainerView/ContainerView';
import LivePreview from '../../Components/LivePreview/LivePreview';
import PreviewDrawer from '../../Components/PreviewDrawer/PreviewDrawer';
import EditorArea from '../../Components/EditorArea/EditorArea';
import PreviewArea from '../../Components/PreviewArea/PreviewArea';
import { Typography } from '@mui/material';
import { DashboardView } from 'utils/enums';
import { DASHBOARD_TITLE } from 'utils/constants';

const DashboardContent = () => {
  const { view } = useDashboard();
  const { t } = useTranslation();
  const { showToast } = useToast();
  const { state, loading, error } = useProfile();
  const [existChange, setExistChange] = useState(false);
  const [openDeployed, setOpenDeployed] = useState(false);
  const scrollRef = useRef(null);
  const showLivePreview = view === DashboardView.PROFILE || view === DashboardView.LINKS || view === DashboardView.APPEARANCE;
  const narrowLayout = view !== DashboardView.DASHBOARD;
  const didInitRef = useRef(false);

  useEffect(() => {
    if (error) showToast('error', t('profile.error.internal-error'));
  // eslint-disable-next-line
  }, [error]);

  useEffect(() => {
    if (!loading && !didInitRef.current) {
      didInitRef.current = true;
      if (state.isPublished) {
        const timer = setTimeout(() => setOpenDeployed(true), 1000);
        return () => clearTimeout(timer);
      }
    }
  // eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    if (JSON.stringify(state.lastProfile) !== JSON.stringify(state.currentProfile)) {
      setExistChange(true);
      setOpenDeployed(true);
    } else {
      setExistChange(false);
      if (!state.isPublished) setOpenDeployed(false);
    }
  }, [state]);

  return (
    <Drawer scrollRef={scrollRef}>
      <ContainerView hasPreview={showLivePreview} narrow={narrowLayout}>
        <Typography className='title-section' variant="h5" component="h5" align='left' sx={{ color: 'text.primary' }}>
          {t(DASHBOARD_TITLE[view])}
        </Typography>
        <EditorArea>
          {view === DashboardView.DASHBOARD && <Main />}
          {view === DashboardView.PROFILE && <Profile />}
          {view === DashboardView.LINKS && <Links />}
          {view === DashboardView.APPEARANCE && <Appearance />}
          {view === DashboardView.PREVIEW && <Preview />}
          {view === DashboardView.SETTINGS && <Settings />}
        </EditorArea>
        {showLivePreview && (
          <PreviewArea scrollRef={scrollRef}>
            <LivePreview />
          </PreviewArea>
        )}
      </ContainerView>
      {showLivePreview && <PreviewDrawer />}
    </Drawer>
  );
}

const Dashboard = () => (
  <DashboardProvider>
    <ProfileProvider>
      <AnalyticsProvider>
        <DashboardContent />
      </AnalyticsProvider>
    </ProfileProvider>
  </DashboardProvider>
);

export default Dashboard;
